import * as React from 'react';
import { Box, Button, Collapse, Container, Drawer, Grid, List, ListItem, ListItemButton, ListItemIcon } from '@mui/material';
import Hamburger from 'hamburger-react'
import { useLocation } from 'react-router';
import Logo from '../../ui/Logo/Logo';
import ContentTitle from '../ContentTitle/ContentTitle';
import { PAGE } from '../../../constants/page';
import NavButton from '../../ui/NavBUtton/NavButton';
import { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

interface Props {
  children?: React.ReactElement<unknown>;
}

interface Menu {
  text: string
  subText: string
  url: string
  subMenu: Array<Menu>
}

const navLinks: Array<Menu> = [
  {
    text: PAGE.TOP.NAME,
    subText: PAGE.TOP.TEXT,
    url: PAGE.TOP.PATH,
    subMenu: []
  },
  {
    text: PAGE.SERVICE.NAME,
    subText: PAGE.SERVICE.TEXT,
    url: PAGE.SERVICE.PATH,
    subMenu: [
      {
        text: 'FEATURE',
        subText: 'サービスの特長',
        url: PAGE.SERVICE.PATH + '#feature',
        subMenu: []
      },
      {
        text: 'PROCESS',
        subText: 'プロセス事例',
        url: PAGE.SERVICE.PATH + '#process',
        subMenu: []
      },
      {
        text: 'SYSTEM',
        subText: 'システム開発',
        url: PAGE.SYSTEM.PATH,
        subMenu: []
      },
      {
        text: 'SOFTWARE',
        subText: 'ソフトウェア開発',
        url: PAGE.SOFTWARE.PATH,
        subMenu: []
      }
    ]
  },
  {
    text: PAGE.NEWS.NAME,
    subText: PAGE.NEWS.TEXT,
    url: PAGE.NEWS.PATH,
    subMenu: []
  },
  {
    text: PAGE.RECRUIT.NAME,
    subText: PAGE.RECRUIT.TEXT,
    url: PAGE.RECRUIT.PATH,
    subMenu: [
      {
        text: 'NEW GRADS',
        subText: '新卒採用情報',
        url: PAGE.RECRUIT.PATH + '#newgrads',
        subMenu: []
      },
      {
        text: 'EXPERIENCED',
        subText: '経験者採用情報',
        url: PAGE.RECRUIT.PATH + '#experienced',
        subMenu: []
      },
      {
        text: 'STEPS',
        subText: '採用フロー',
        url: PAGE.RECRUIT.PATH + '#steps',
        subMenu: []
      }
    ]
  },
  {
    text: PAGE.COMPANY.NAME,
    subText: PAGE.COMPANY.TEXT,
    url: PAGE.COMPANY.PATH,
    subMenu: [
      {
        text: 'PROFILE',
        subText: '会社概要',
        url: PAGE.COMPANY.PATH + '#profile',
        subMenu: []
      },
      {
        text: 'ACCESS',
        subText: '所在地',
        url: PAGE.COMPANY.PATH + '#access',
        subMenu: []
      }
    ]
  },
  {
    text: PAGE.CONTACT.NAME,
    subText: PAGE.CONTACT.TEXT,
    url: PAGE.CONTACT.PATH,
    subMenu: []
  },
];

/** 表示中の画面か判定 */
const isCurrent = (currentPath: string, pattern: string): boolean => {
  if (currentPath === pattern) {
    return true
  } else {
    if (pattern.slice(1)) {
      return currentPath.slice(1).indexOf(pattern.slice(1)) === 0
    } else {
      return false
    }
  }
}

export default function Header(props: Props) {
  const [menuExpands, setMenuExpands] = useState<Array<string>>([])
  const [isOpen, setIsOpen] = useState(false)
  const [menu, setMenu] = useState<Menu>({
    subMenu: [],
    subText: '',
    text: '',
    url: ''
  })
  const [showDropdown, setShowDropdown] = useState(false)
  const location = useLocation()
  const handleDrawer = (value: boolean) => {
    setIsOpen(value);
  }

  /** メニュー展開処理 */
  const handleMenuExpand = (value: string) => {
    if (menuExpands.includes(value)) {
      setMenuExpands(menuExpands.filter(m => m !== value))
    } else {
      setMenuExpands([...menuExpands, value])
    }
  }

  return (
    <>
      <Box
        component={'header'}
        sx={(theme) => ({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 1300
        })}
      >
        <Box
          component={'nav'}
          sx={(theme) => ({
            position: 'relative',
            backgroundColor: theme.palette.grey[50],
            color: theme.palette.grey[900],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
            height: 90,
            minHeight: 90,
            maxHeight: 90,
            borderBottom: 10,
            borderBottomStyle: 'solid',
            borderColor: theme.palette.grey[900],
            opacity: 0.95
          })}
          onMouseLeave={() => {
            setMenu({
              subMenu: [],
              subText: '',
              text: '',
              url: ''
            })
            setShowDropdown(false)
          }}
        >
          <Logo />
          <Box sx={(theme) => ({
            padding: '10px',
            whiteSpace: 'nowrap',
            marginLeft: 'auto',
            'button': { color: theme.palette.grey[900] },
          })}>
            <Box
              sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}
            >
              {navLinks.map((navLink, index) => (
                <NavButton
                  key={`navlink${index}`}
                  href={navLink.url}
                  text={navLink.text}
                  subText={navLink.subText}
                  isActive={isCurrent(location.pathname, navLink.url)}
                  margin={'0 0.25rem'}
                  onMouseEnter={() => {
                    setShowDropdown(true)
                    setMenu(navLink)
                  }}
                />
              ))}
              <Button size='large' onClick={() => handleDrawer(!isOpen)}>
                <Hamburger toggled={isOpen} />
              </Button>
            </Box>
            <Box sx={{ display: { md: 'block', lg: 'none' } }}>
              <Button size='large' onClick={() => handleDrawer(!isOpen)}>
                <Hamburger toggled={isOpen} />
              </Button>
            </Box>
          </Box>
          <Drawer open={isOpen} onClose={() => handleDrawer(!isOpen)} anchor={'right'} PaperProps={{
            style: {
              top: 100,
              height: 'calc(100% - 100px)',
              display: 'flex',
              flexDirection: 'column'
            },
            sx: (theme) => ({
              backgroundColor: theme.palette.grey[50],
              color: theme.palette.grey[900],
            })
          }}>
            <Box sx={(theme) => ({
              display: 'flex',
              justifyContent: 'center',
            }
            )}>
              <ContentTitle title="MENU" padding='0' fontSize='2.5rem' />
            </Box>
            <Box sx={(theme) => ({
              width: '380px',
              padding: '10px',
              flexGrow: 1,
            }
            )}>
              <Box>
                <List
                  sx={{ width: '100%' }}
                  component="nav"
                >
                  {navLinks.map((navLink, index) => (
                    <Box key={`menu${index}`} >
                      <ListItemButton sx={{ padding: 0, margin: 0 }}>
                        <NavButton
                          width={'100%'}
                          textAlign='left'
                          activeDisabled
                          href={navLink.url}
                          text={navLink.text}
                          subText={navLink.subText}
                        />
                        {
                          navLink.subMenu.length !== 0 &&
                          <ListItemIcon sx={{ display: 'flex', justifyContent: 'center', padding: 2.5 }} onClick={() => handleMenuExpand(navLink.text)}>
                            {menuExpands.includes(navLink.text) ? <ExpandMore /> : <ExpandLess />}
                          </ListItemIcon>
                        }
                      </ListItemButton>
                      <Collapse in={menuExpands.includes(navLink.text)} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                          {navLink.subMenu.map((sm, si) => (
                            <ListItemButton key={`submenu${si}`} sx={{ pl: 4, padding: 0, margin: 0, marginLeft: '2rem' }}>
                              <NavButton
                                width={'100%'}
                                textAlign='left'
                                activeDisabled
                                href={sm.url}
                                text={sm.text}
                                subText={sm.subText}
                              />
                            </ListItemButton>
                          ))}
                        </List>
                      </Collapse>
                    </Box>
                  ))}
                </List>
              </Box>
            </Box>
            <Box sx={(theme) => ({
              display: 'flex',
              justifyContent: 'center',
              padding: '5px 10px',
              background: theme.palette.grey[900],
            }
            )}>
              <Logo color='dark' />
            </Box>
          </Drawer>
          <Box
            sx={(theme) => ({
              position: 'absolute',
              top: 90,
              left: 0,
              overflow: 'hidden',
              width: '100%',
              transformOrigin: 'top',
              transform: `scaleY(${showDropdown ? 1 : 0})`,
              backgroundColor: theme.palette.grey[50],
              color: theme.palette.grey[900],
              borderBottom: 10,
              borderBottomStyle: 'solid',
              borderColor: theme.palette.grey[900],
            })}
          >
            {
              menu.subMenu.length !== 0 &&
              <Container>
                <Grid container>
                  <Grid size={2}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Box sx={{ marginBottom: '2rem' }}>
                        <ContentTitle padding={'0'} fontSize={'1.5rem'} title={menu.text} subTitle={menu.subText} />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid size={10} sx={{ padding: '1rem' }}>
                    <List sx={{ padding: 0, height: '100%', display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                      {menu.subMenu.map((sm, si) => {
                        return (
                          <ListItem key={`navsub${si}`} disablePadding sx={{ width: 'auto' }}>
                            <NavButton
                              margin={'0 0.5rem'}
                              activeDisabled
                              href={sm.url}
                              text={sm.text}
                              subText={sm.subText}
                            />
                          </ListItem>
                        )
                      })}
                    </List>
                  </Grid>
                </Grid>
              </Container>
            }
          </Box>
        </Box>
      </Box >
    </>
  );
}